const sanitizeFileName = (value: string) =>
  value.replace(/[<>:"/\\|?*\u0000-\u001F]/g, '_').trim() || 'download'

const triggerBlobDownload = (blob: Blob, fileName: string) => {
  const url = window.URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = fileName
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  window.URL.revokeObjectURL(url)
}

export const parseFilenameFromContentDisposition = (header?: string | null): string | null => {
  if (!header) return null
  const utf8Match = header.match(/filename\*=UTF-8''([^;]+)/i)
  if (utf8Match?.[1]) {
    try {
      return decodeURIComponent(utf8Match[1].trim())
    } catch {
      return utf8Match[1].trim()
    }
  }
  const quotedMatch = header.match(/filename="([^"]+)"/i)
  if (quotedMatch?.[1]) return quotedMatch[1].trim()
  const plainMatch = header.match(/filename=([^;]+)/i)
  if (plainMatch?.[1]) return plainMatch[1].trim().replace(/^"|"$/g, '')
  return null
}

export const downloadBlobFile = (blob: Blob, filename: string) => {
  triggerBlobDownload(blob, sanitizeFileName(filename || 'download') || 'download')
}

export const parseApiErrorMessageFromBlob = async (
  data: unknown,
  fallback = 'Could not generate requisition document. Please try again.'
): Promise<string> => {
  if (!(data instanceof Blob)) {
    return fallback
  }
  try {
    const text = await new Promise<string>((resolve, reject) => {
      const reader = new FileReader()
      reader.onload = () => resolve(String(reader.result || ''))
      reader.onerror = () => reject(reader.error || new Error('Failed to read error response'))
      reader.readAsText(data)
    })
    if (!text) return fallback
    try {
      const parsed = JSON.parse(text) as {message?: string; error?: string}
      return parsed.message || parsed.error || fallback
    } catch {
      return text.trim() || fallback
    }
  } catch {
    return fallback
  }
}
